<template>
    <div class="fill_form mt20 m0 mb30 clearfix" key="workEdit">
      <ul class="fr operation_list">
        <li class="fl" @click="save">保存</li>
        <li class="fl" @click="cancel">取消</li>
      </ul>
      <!--标题-->
    <vue-form :state="formstate">
      <h3 class="form_title clearfix"><span>| </span>基本信息
      </h3>

      <!-- 标题 end-->
      <div class="fill_group_row clearfix fl w_half">

        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>姓名</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input time_icon" name="username" required v-model="params.user.username" type="text"/>
            <field-messages name="username" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">姓名不能为空</div>
            </field-messages>
          </div>
        </validate>
        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>性别</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select time_icon" name="sex" required v-model="params.user.sex">
              <option value="1">男</option>
              <option value="2">女</option>
            </select>
            <field-messages name="sex" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">姓别不能为空</div>
            </field-messages>
          </div>
        </validate>
        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>民族</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" name="mobile" required type="text" v-model="params.user.nation" />
            <field-messages name="mobile" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">民族不能为空</div>
            </field-messages>
          </div>
        </validate>
        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>参加工作日期</label>
          <div class="form_control w_auto ">
            <!--<vue-datepicker-local class="i_w300 form_input date_picker_out" required v-model="params.user.work_time" name="workDate"></vue-datepicker-local>-->
            <input class="i_w300 form_input" name="workDate" placeholder="xxxx/xx/xx" required type="text" v-model="params.user.work_time"  />
            <field-messages name="workDate" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">参加工作日期不能为空</div>
            </field-messages>
          </div>
        </validate>
        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>工作单位</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select" name="companyName" type="text" required v-model="params.user.company_id" pattern="^[1-9]\d*$">
              <option value=0>请选择单位</option>
              <option :value="item.id" v-for="(item,index) in companyData">{{item.company_name}}</option>
            </select>
            <field-messages name="companyName" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">工作单位不能为空</div>
              <div slot="pattern" class="errorMessage">工作单位不能为空</div>
            </field-messages>
          </div>
        </validate>

      </div>
      <div class="fill_group_row clearfix fr w_half">

        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>社会保障号</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input time_icon" @blur="takeBirthday" name="socialSecurityAccount" pattern="^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$" required type="text" v-model="params.user.social_security_account"/>
            <field-messages name="socialSecurityAccount" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">居民身份证不能为空</div>
              <div slot="pattern" class="errorMessage">请输入正确的居民身份证号</div>
            </field-messages>
          </div>
        </validate>
        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>出生日期</label>
          <div class="form_control w_auto ">
            <!--<vue-datepicker-local class="i_w300 form_input date_picker_out" required v-model='params.user.birthday' name="birthday"></vue-datepicker-local>-->
            <input class="i_w300 form_input" placeholder="xxxx/xx/xx" name="birthday" required type="text" v-model="params.user.birthday"  />
            <field-messages name="birthday" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">出生日期不能为空</div>
            </field-messages>
          </div>
        </validate>
        <!--<validate tag="div" class="form_group clearfix">-->
          <!--<label class="control_label "><em>*</em>工作单位</label>-->
          <!--<div class="form_control w_auto ">-->
            <!--<input class="i_w300 form_input" name="company_name" required type="text" v-model="params.user.work_unit_name" />-->
            <!--<field-messages name="company_name" show="$dirty || $touched || $submitted">-->
              <!--<div slot="required" class="errorMessage">工作单位不能为空</div>-->
            <!--</field-messages>-->
          <!--</div>-->
        <!--</validate>-->
        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>联系手机</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" name="mobile" required pattern="^[1][0-9]{10}$" type="text" v-model="params.user.mobile" />
            <field-messages name="mobile" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">联系手机不能为空</div>
              <div slot="pattern" class="errorMessage">请填写正确的手机号</div>
            </field-messages>
          </div>
        </validate>
        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>邮政编码</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" type="text" name="postalCode" required pattern="^[1-9][0-9]{5}$" v-model='params.user.postal_code'/>
            <field-messages name="postalCode" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">邮政编码不能为空</div>
              <div slot="pattern" class="errorMessage">请输入正确的邮政编码</div>
            </field-messages>
          </div>
        </validate>
        <div class="form_group clearfix">
          <label class="control_label ">固定电话</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input"  type="text" v-model='params.user.telephone'/>
          </div>
        </div>

      </div>
      <div class="fill_group_row clearfix">
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>户籍所在地</label>
          <div class="form_control w_auto">

            <div class="flex fl" style="position: relative;">
              <div class="w_375">
                <validate tag="div" class="fl">
                  <select class="form_select s_w120" name="domicileProvince" required v-model='params.user.domicile_province'>
                    <option value="">省</option>
                    <option v-for="(item,index) in areas.allArr" :value="index">
                      {{item.name}}
                    </option>
                  </select>
                  <field-messages name="domicileProvince" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">省不能为空</div>
                  </field-messages>
                </validate>
                <validate tag="div" class="fl" style="position: relative; margin-left: 4px;">
                  <select class="form_select s_w120" name="domicileCity" required v-model='params.user.domicile_city'>
                    <option value="">市</option>
                    <option v-for="(item,index) in areas.domicileCities" :value="index">{{item.name}}</option>
                  </select>
                  <field-messages name="domicileCity" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">市不能为空</div>
                  </field-messages>
                </validate>
                <validate tag="div" class="fl" style="position: relative; margin-left: 4px;">
                  <select class="form_select s_w120" name="domicileDistrict" required v-model='params.user.domicile_district'>
                    <option value="">区</option>
                    <option v-for="(item,index) in areas.domicileDistrict" :value="index">{{item.name}}</option>
                  </select>
                  <field-messages name="domicileDistrict" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">区不能为空</div>
                  </field-messages>
                </validate>
              </div>
              <validate tag="div" class="auto_flex" style="position: relative;">
                <input class=" form_input time_icon w100" required type="text" name="domicileDetail" v-model='params.user.domicile_detail'/>
                <field-messages name="domicileDetail" show="$dirty || $touched || $submitted">
                  <div slot="required" class="errorMessage">户籍所在地详情不能为空</div>
                </field-messages>
              </validate>
            </div>

          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>通讯地址</label>
          <div class="form_control w_auto">

            <div class="flex fl" style="position: relative;">
              <div class="w_375">
                <validate tag="div" class="fl" >
                  <select class="form_select s_w120" name="address_province" required v-model="params.user.address_province">
                    <option value="">省</option>
                    <option v-for="(item,index) in areas.allArr" :value="index">
                      {{item.name}}
                    </option>
                  </select>
                  <field-messages name="address_province" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">省不能为空</div>
                  </field-messages>
                </validate>
                <validate tag="div" class="fl" style="position: relative; margin-left: 4px;">
                  <select class="form_select s_w120" name="address_city" required v-model="params.user.address_city">
                    <option value="">市</option>
                    <option v-for="(item,index) in areas.addressCities" :value="index">{{item.name}}</option>
                  </select>
                  <field-messages name="address_city" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">市不能为空</div>
                  </field-messages>
                </validate>
                <validate tag="div" class="fl" style="position: relative; margin-left: 4px;">
                  <select class="form_select s_w120" name="address_district" required v-model='params.user.address_district'>
                    <option value="">区</option>
                    <option v-for="(item,index) in areas.addressDistrict" :value="index">{{item.name}}</option>
                  </select>
                  <field-messages name="address_district" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">区不能为空</div>
                  </field-messages>
                </validate>
              </div>
              <validate tag="div" class="auto_flex" style="position: relative;">
                <input class=" form_input time_icon w100" type="text" name="address_detail" required v-model="params.user.address_detail"/>
                <field-messages name="address_detail" show="$dirty || $touched || $submitted">
                  <div slot="required" class="errorMessage">通讯地址详情不能为空</div>
                </field-messages>
              </validate>

            </div>

          </div>
        </div>
      </div>


      <!--标题-->
      <h3 class="form_title clearfix"><span>| </span>2014年9月30日前人事信息
      </h3>
      <!-- 标题 end-->
      <div class="fill_group_row clearfix w_half">
        <validate tag="div" class="auto_flex">
          <label class="control_label "><em>*</em>改革时人员类别</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select time_icon" name="specialType" required v-model="params.special.type">
              <option value="">请选择</option>
              <option value="1">事业单位专业技术人员</option>
              <option value="2">事业单位管理人员</option>
              <option value="3">事业单位工人</option>
            </select>
            <field-messages name="specialType" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">改革时人员类别不能为空</div>
            </field-messages>
          </div>
        </validate>
      </div>

      <!--标题-->
      <h3 class="form_title clearfix"><span>| </span>参保信息
      </h3>
      <!-- 标题 end-->
      <div class="clearfix">
        <div class="fill_group_row clearfix fl w_half">
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>参保日期</label>
            <div class="form_control w_auto ">
              <!--<vue-datepicker-local class="i_w300 form_input date_picker_out" v-model='params.insurance.insured_time' required name="insuredTime"></vue-datepicker-local>-->
              <input class="i_w300 form_input" placeholder="xxxx/xx/xx" name="insuredTime" required type="text" v-model="params.insurance.insured_time"  />
              <field-messages name="insuredTime" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">参保日期不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>编制类型</label>
            <div class="form_control w_auto ">
              <select class="i_w300 form_select time_icon" name="compilationType" required v-model="params.insurance.compilation_type">
                <option value="1">事业</option>
              </select>
              <field-messages name="compilationType" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">编制类型不能为空</div>
              </field-messages>
            </div>
          </validate>
        </div>
        <div class="fill_group_row clearfix fr w_half">

          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>首次参保年月</label>
            <div class="form_control w_auto ">
              <!--<vue-datepicker-local class="i_w300 form_input date_picker_out" v-model='params.insurance.first_insured_time' required name="firstInsuredTime"></vue-datepicker-local>-->

              <input class="i_w300 form_input" placeholder="xxxx/xx/xx" name="firstInsuredTime" required type="text" v-model="params.insurance.first_insured_time"  />
              <field-messages name="firstInsuredTime" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">首次参保年月不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>账户建立年月</label>
            <div class="form_control w_auto ">
              <!--<vue-datepicker-local class="i_w300 form_input date_picker_out" v-model='params.insurance.account_creation_time' required name="account_creation_time"></vue-datepicker-local>-->
              <input class="i_w300 form_input" placeholder="xxxx/xx/xx" name="account_creation_time" required type="text" v-model="params.insurance.account_creation_time"  />
              <field-messages name="account_creation_time" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">账户建立年月不能为空</div>
              </field-messages>
            </div>
          </validate>
        </div>
      </div>
    </vue-form>
      <msgTips v-show="showFlag" @confirm="layerConfirm" @cancel="layerCancel" title="提示">
        <p class="layer_content">退出编辑后将不会保留新编辑内容，确定退出？</p>
      </msgTips>
      <toastTips :content="toastContent" :is-show="toast"></toastTips>
    </div>
</template>
<script>
  import VueDatepickerLocal from 'vue-datepicker-local'
  import locations from '../../libs/location_libs'
  import axios from 'axios'
  import qs from 'qs'
  import msgTips from '../../components/layer/msgTips'
  import toastTips from '../../components/layer/toastTips'
  import moment from 'moment'


  export default {
    name:'editList',
    components:{
      VueDatepickerLocal,
      msgTips,
      toastTips
    },
    data(){
      return {
        tableTittles:['开始时间','截止时间','缴费基数','操作'],
        areas:{
          allArr:locations.locations,
          domicileCities:'',
          addressDistrict:'',
          domicileDistrict:'',
          addressCities:''
        },
        showFlag:false,
        toast:false,
        toastContent:'',
        formstate:{},
        id:this.$route.params.id,
        report_province:'',
        report_city:'',
        report_area:'',
        userInfo:[],
        companyData:[],
        params:{
          type:1,
          user:{
            username:'',
            idcard:'',
            social_security_account:'',
            type:'',
            sex:1,
            birthday:'',
            work_time:'',
            mobile:'',
            telephone:'',
            nation:'',
            domicile_province:'',
            domicile_city:'',
            domicile_district:'',
            domicile_detail:'',
            company_id:0,
            work_unit_name:'',
            address_province:'',
            address_city:'',
            address_district:'',
            address_detail:'',
            postal_code:''
          },
          special:{
            type:1
          },
          insurance:{
            insured_time:'',
            first_insured_time:'',
            compilation_type:1,
            account_creation_time:''
          }
        },
        isSave:true
      }
    },
    created:function(){
      this.$router.beforeEach((to,from,next)=>{
        if(this.$route.path=='/add/worker/0/edit/-1' && this.isSave){
          const answer = window.confirm('当前页面处于编辑状态确认要退出？');
          if (answer) {
            next()
          } else {
            next(false)
          }
        }else{
          next();
        }

      })
    },
    mounted: function () {
      var that=this;
      axios.get('/admin/company/list',{

      }).then((response)=>{
        if(response.data.code == 22000){
          that.companyData = response.data.result.list;
        }else if(response.data.code==50001){
          window.location.href='/#/login'
        }else{
          that.toast=true;
          that.toastContent=response.data.message;
          setTimeout(function(){
            that.toast=false;
            that.toastContent='';
          },3000)
        }
      });
      if(this.id > 0) {
        axios.get('/user/getInfo',{
          params:{
            id:that.id
          }
        }).then((response)=>{
          if(response.data.code==22000){
            var result = response.data.result;
            for(var key in result){
              for(var item in result[key]){
                if(typeof(result[key][item])=='string' && result[key][item].indexOf('-')>0
                  && result[key][item].split('-')[0]=='0000'){
                  result[key][item]='';
                }
              }
            }
            that.params=result;
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }
        })
      }
     that.params.user.domicile_province = '330000';
     that.params.user.domicile_city = '330100';
     that.params.user.address_province = '330000';
     that.params.user.address_city = '330100';
    },
    methods:{
      updateCity:function(cities,province){
        this.areas[cities] =this.areas.allArr[province].sub
      },
      updateDistrict:function(district,cities,province){
        this.areas[district] =this.areas.allArr[province].sub[cities].sub
      },
      save:function(){
        var that=this,
            tipBox = document.getElementsByClassName('tipsBox')[0];

        that.params.user.work_time =  moment(that.params.user.work_time).format("YYYY-MM-DD")
        that.params.user.birthday =  moment(that.params.user.birthday).format("YYYY-MM-DD")
        that.params.insurance.insured_time =  moment(that.params.insurance.insured_time).format("YYYY-MM-DD")
        that.params.user.birthday =  moment(that.params.user.birthday).format("YYYY-MM-DD")
        that.params.insurance.account_creation_time =  moment(that.params.insurance.account_creation_time).format("YYYY-MM-DD")
        if(!that.formstate.$invalid) {
          if(that.id>0){
            that.params['id'] = that.id;
            axios.post('/user/update', that.params).then((response)=>{
              if(response.data.code==22000){
                this.isSave=false;
                that.toastContent='修改成功';
                tipBox.style.display='block';
                setTimeout(function(){
                  tipBox.style.display='none';
                  window.location.href='/#/add/worker/0/see/'+response.data.result.id;
                  window.location.reload();
                },3000);
              }else if(response.data.code==50001){
                this.isSave=false;
                window.location.href='/#/login';
              }else{
                that.toastContent=response.data.message;
                tipBox.style.display='block';
                setTimeout(function(){
                  tipBox.style.display='none';
                },3000);
              }
            })
          }else{
            axios.post('/user/create', that.params).then((response)=>{
              if(response.data.code==22000){
                this.isSave=false;
                that.toastContent='保存成功';
                tipBox.style.display='block';
                that.showFlag = false
                setTimeout(function(){
                  tipBox.style.display='none';
                  window.location.href='/#/list/0';
                  window.location.reload();
                },3000);
              }else if(response.data.code==50001){
                this.isSave=false;
                window.location.href='/#/login';
              }else{
                this.isSave=false;
                that.toastContent=response.data.message;
                tipBox.style.display='block';
                setTimeout(function(){
                  tipBox.style.display='none';
                },3000);
              }
            })
          }
        } else {
          that.formstate._submit();
        }
      },
      cancel:function(){
          this.isSave=false;
          this.showFlag = true;
      },
      layerConfirm:function(){
          this.showFlag = false;
          window.location.href='/#/list/0';
          window.location.reload();
      },
      layerCancel:function(){
          this.isSave=true;
          this.showFlag = false;
      },
      takeBirthday:function(){
        if(this.params.user.social_security_account)
        this.params.user.birthday=this.params.user.social_security_account.substr(6,4)+'-'+this.params.user.social_security_account.substr(10,2)+'-'+this.params.user.social_security_account.substr(12,2)
        if(parseInt(this.params.user.social_security_account.substr(16,1))%2==1) {
          this.params.user.sex = 1
        }
        else {
          this.params.user.sex = 2
        }
      }

    },
    watch:{
      'params.user.domicile_province' : function(){
        this.updateCity('domicileCities',this.params.user.domicile_province);
      },
      'params.user.address_province' : function(){
        this.updateCity('addressCities',this.params.user.address_province);
      },
      'params.user.domicile_city' : function(){
        this.updateDistrict('domicileDistrict',this.params.user.domicile_city,this.params.user.domicile_province);

      },
      'params.user.address_city' : function(){
        this.updateDistrict('addressDistrict',this.params.user.address_city,this.params.user.address_province);
      }
    }
  }
</script>
<style lang="less" scoped>
  .w_375{
    width: 375px!important;;
  }
  .w100{
    width:85%!important;
  }
  .flex{
    display: flex;
    width:90%;
  }
  .auto_flex{
    flex:.94;
  }
  .table_outer_box{
    margin-bottom: 30px;
  }
  .history_info_box{
    position: relative;
  .line_box{
    position: absolute;
    left: 91px;
    height: 100%;
    border-right: 1px solid #e1e7f6;
  }
  .history_info{
    /*padding-left: 39px;*/
    margin-bottom: 40px;
  .history_left{
    float: left;
    width: auto;
    text-align: right;
  }
  .history_right{
    float: left;
    margin-left: 50px;
  p{
    color: #32363a;
  span{
    color: #32363a;
  }
  .edition_change_info{
    margin-left: 10px;
    color: #aaa;
  }
  }
  .history_info_tit{
    position: relative;
    margin-bottom: 10px;
  .blue_dot{
    position: absolute;
    top:9px;
    left: -6px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #0080ea;
  }
  }
  }
  }
  }
  .date_picker_out{
    padding:0!important;
    input{
      border:none !important;
      width:100%!important;
    }
  }
  .operation_list{
    position:absolute;
    right:20px;
    top:0;
    li{
      cursor: pointer;
      padding-left: 30px;
      margin-left: 22px;
      line-height: 50px;
    }
  }
  .layer_content{
    text-align: center;
    line-height: 80px;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/editList/workerEdit.vue